import React from "react";
import { useLocation } from "react-router";
import LoginDesktopHeader from "./DesktopHeader";

const TITLE = "RushmyFood";

const REGISTRATION_PATH = [
  "/login",
  "/new-login",
  "/registration",
  "/login-email",
  "/forgot-password",
  "/email-sent",
  "/phone-number",
  "/verify-email"
];

// Pages that should show the simple header (no delivery/pickup toggle, search, etc.)
const SIMPLE_HEADER_PATHS = [
  "/",
  "/login",
  "/new-login",
  "/registration",
  "/login-email",
  "/forgot-password",
  "/email-sent",
  "/phone-number",
  "/verify-email",
  "/privacy",
  "/terms"
];

function Header({ showIcon = false }) {
  const location = useLocation();
  const showCart = !REGISTRATION_PATH.includes(location.pathname);
  const showFullHeader = !SIMPLE_HEADER_PATHS.includes(location.pathname);

  return (
    <LoginDesktopHeader
      showIcon={showIcon}
      title={TITLE}
      showCart={showCart}
      showFullHeader={showFullHeader}
    />
  );
}

export default React.memo(Header);
